// import Head from "next/head";
// import Image from "next/image";
import styles from "../styles/Home.module.css";
import { Link, useHref } from "react-router-dom";
import useWindowSize from "../hooks/useWindowSize";
import { useEffect } from "react";
// import Page from "@/components/Page";

export default function Home() {
    const { width, height } = useWindowSize();
    const winRatio = width / height;

    useEffect(() => {
        document.title = "Math With Maki | Home"
    }, []);

    return (
        <>
            <head>
                <title>Math with Maki</title>
                <meta name="description" content="Math with Maki" />
                <link rel="icon" href="/favicon.ico" />
            </head>
            {/* <Page>
                <h2>Hi I'm Professor Maki</h2>
            </Page> */}
            <main className={`${styles.main}`}>
                <a
                    href="/math150"
                    style={{ background: "#6A8EAE" }}
                    className={styles.pageBtn}
                >
                    <div>
                        <h2>
                            <span
                                style={{
                                    fontSize: winRatio > 1 ? "1.25em" : "0.7em",
                                }}
                            >
                                MATH
                            </span>
                            <br></br>
                            <span
                                style={{
                                    fontSize: winRatio > 1 ? "1.35em" : "0.8em",
                                }}
                            >
                                150/151
                            </span>
                        </h2>
                    </div>
                </a>
                <a
                    href="/math254"
                    style={{ background: "#A1C6EA" }}
                    className={styles.pageBtn}
                >
                    <div>
                        <h2>
                            <span
                                style={{
                                    fontSize: winRatio > 1 ? "1.25em" : "0.7em",
                                }}
                            >
                                MATH
                            </span>
                            <br></br>
                            <span
                                style={{
                                    fontSize: winRatio > 1 ? "1.35em" : "0.8em",
                                }}
                            >
                                254/245
                            </span>
                        </h2>
                    </div>
                </a>
            </main>
        </>
    );
}
